import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import { apis } from '../api/index.js';
import './user.css';
import i18n from 'i18next';
import TableEmpty from '../components/TableEmpty.js';
import { message, Breadcrumb, Icon, Form, Select } from 'antd';
import { Button, Input, Table, Modal } from 'antd';
import throttle from 'lodash.throttle';

import UserAdd from './UserAdd.js';
import { formatDate, breadBack, changeListWidth } from '../utils';
import { getInstitutionOptions, setScrollTop, breadItem } from '../utils';
import { institutionRecord, calcTableHeight, showMoreSearch } from '../utils';
import { loadingOptionsHtml } from '../utils';
import _ from 'lodash';

const { Option } = Select;
const { confirm } = Modal;

class UserManager extends Component {
  constructor(props) {
    super(props);

    this.throttledUserList = throttle(newState => {
      setScrollTop();
      this.getUserList(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(165) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  state = {
    listWidth: 'calc(87% - 8px)',
    institutionData: [],
    userList: [],
    addModalVisible: false,
    nickName: '',
    accountName: '',
    status: '',
    institutionIds: [],
    userTypeList: [],
    roleInfoRecordList: [],
    userDetail: {},
    selectedRowKeys: '',
    searchLoading: true,
    tableHeight: 0,
    moreFilter: true,
    showMoreFilter: false,
  };

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    form: PropTypes.object,
  };

  componentDidMount() {
    this.getInstitutionData();
    this.throttledUserList();
    this.getUserInfo();
    window.addEventListener('resize', () => this.formResize());
    this.formResize();
  }

  getUserList = newState => {
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const post = _.pick(updatedState, [
      'nickName',
      'accountName',
      'status',
      'institutionIds',
      'sortBy',
      'sort',
    ]);
    apis.boxUserRecord(post).then(res => {
      this.setState({ searchLoading: false });
      if (res.code === '1009') {
        this.props.history.push('/login');
      } else {
        this.setState({ userList: res.code === '0' ? res.data : [] });
      }
    });
  };

  getUserInfo = () => {
    const type = Promise.resolve(apis.userTypes());
    const role = Promise.resolve(apis.roleInfoRecord());
    Promise.all([type, role]).then(res => {
      const [type, role] = res;
      if (type.code === '0' && role.code === '0')
        this.setState({
          userTypeList: type.data,
          roleInfoRecordList: role.data,
        });
      else if (type.code === '1009' || role.code === '1009')
        this.props.history.push('/login');
    });
  };

  //获取机构列表
  getInstitutionData = async name => {
    const data = await institutionRecord(name);
    this.setState({ institutionData: data });
  };

  //点击重置按钮
  handleReset = () => {
    this.props.form.resetFields();
  };

  getInstitutionNames = list => {
    let names = list.map(item => item.institutionName);
    return names.join(', ');
  };

  getUserTypeValues = list => {
    let types = list.map(item => item.userType);
    return types.join(', ');
  };

  getRoleNames = list => {
    let names = list.map(item => item.roleName);
    return names.join(', ');
  };

  getColumns = () => {
    const columns = [
      {
        title: i18n.t('username'), //用户姓名
        dataIndex: 'nickName',
        key: 'nickName',
        width: '10%',
      },
      {
        title: i18n.t('account'), //用户账号
        dataIndex: 'accountName',
        key: 'accountName',
        width: '10%',
      },
      {
        title: i18n.t('email'), //邮箱
        dataIndex: 'email',
        key: 'email',
        width: '10%',
      },
      {
        title: i18n.t('institution'), //机构
        dataIndex: 'institutionInfos',
        key: 'institutionInfos',
        width: '10%',
        render: value => <span>{this.getInstitutionNames(value)}</span>,
      },
      {
        title: i18n.t('usertype'), // 用户类型
        dataIndex: 'boxUserTypes',
        key: 'boxUserTypes',
        width: '10%',
        render: value => <span>{this.getUserTypeValues(value)}</span>,
      },
      {
        title: i18n.t('userRole'), //用户角色
        dataIndex: 'roleInfos',
        key: 'roleInfos',
        width: '10%',
        render: value => <span>{this.getRoleNames(value)}</span>,
      },
      {
        title: i18n.t('status'), //状态
        dataIndex: 'status',
        key: 'status',
        width: '10%',
        render: value => <span>{value === 1 ? '启用' : '停用'}</span>,
      },
      {
        title: i18n.t('operateTime'), //操作时间
        dataIndex: 'updateTime',
        key: 'update_time',
        width: '15%',
        sorter: true,
        sortDirections: ['ascend', 'descend'],
        render: value => <span>{formatDate(value)}</span>,
      },
      {
        title: i18n.t('operation'), //操作
        dataIndex: '',
        key: 'operation',
        align: 'center',
        width: '15%',
        render: record => (
          <Button
            type="link"
            className="btn-viewdetail"
            onClick={() => this.showAddModal(record, 'edit')}
          >
            <Icon type="edit" theme="filled" />
            {i18n.t('edit')}
          </Button>
        ),
      },
    ];

    return columns;
  };

  showDeleteConfirm = () => {
    const _this = this;
    confirm({
      title: '删除',
      content: '已选中1条数据，确定删除所选数据吗？',
      okText: '删除',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        apis.deleteBoxUser(_this.state.selectedRowKeys).then(res => {
          if (res.code === '0') {
            message.success('删除成功');
            _this.throttledUserList();
          } else if (res.code === '1009') _this.props.history.push('/login');
        });
      },
    });
  };

  showAddModal = (info, type) => {
    this.setState({
      addModalVisible: true,
      detailType: type,
      userDetail: info || {},
    });
  };

  hideAddModal = changed => {
    setTimeout(() => this.setState({ addModalVisible: false }), 1);

    if (changed) this.throttledUserList();
  };

  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const newState = {
          nickName: values.name,
          accountName: values.account,
          institutionIds: values.institution ? [values.institution] : [],
          status: values.status,
          searchLoading: true,
        };
        this.throttledUserList(newState);
      }
    });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    this.getInstitutionData(value);
  };
  setBackEvent = () => {};

  render() {
    const { getFieldDecorator, tableHeight } = this.props.form;
    const {
      userList,
      institutionData,
      moreFilter,
      showMoreFilter,
    } = this.state;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');
    const columns = this.getColumns();

    const rowSelection = {
      onChange: (selectedRowKeys, selectedRows) => {
        this.setState({ selectedRowKeys });
      },
      type: 'radio',
    };
    const total = userList.length;
    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);

    return (
      <div className="form-bg">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['系统管理', '用户管理'])}</Breadcrumb>
              {breadBack(this)}
            </div>
            <div
              className="box theme-usermanager"
              style={{ width: this.state.listWidth }}
            >
              <div className="left">
                <Form
                  className={`ant-advanced-search-form${
                    !moreFilter && showMoreFilter ? ' notOverflow' : ''
                  }`}
                  onSubmit={this.handleSearch}
                  layout="inline"
                >
                  <div className="searchBox">
                    <div className="searchBoxContent">
                      <Form.Item label="姓名" colon={false}>
                        {getFieldDecorator('name', {})(
                          <Input
                            allowClear={true}
                            placeholder="请输入用户姓名"
                            style={{ width: 160 }}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="账号" colon={false}>
                        {getFieldDecorator('account', {})(
                          <Input
                            allowClear={true}
                            placeholder="请输入账号"
                            style={{ width: 240 }}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="机构" colon={false}>
                        {getFieldDecorator('institution', {})(
                          <Select
                            showSearch
                            placeholder="请选择机构名称"
                            defaultActiveFirstOption={false}
                            filterOption={false}
                            onSearch={this.handleInstitutionSearch}
                            onChange={this.handleChange}
                            notFoundContent={null}
                            allowClear={true}
                            style={{ width: 240 }}
                          >
                            {institutionOptions}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="状态" colon={false}>
                        {getFieldDecorator('status', {})(
                          <Select
                            allowClear={true}
                            placeholder="请选择状态"
                            style={{ width: 160 }}
                          >
                            <Option value="1">启用</Option>
                            <Option value="0">停用</Option>
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="searchOptBox">
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn-search"
                        disabled={this.state.searchLoading}
                      >
                        {this.state.loadingIconShow ? (
                          <Icon type="sync" spin />
                        ) : (
                          <Icon type="search" />
                        )}
                        搜索
                      </Button>
                      <Button
                        icon="redo"
                        style={{ marginLeft: 8 }}
                        disabled={this.state.searchLoading}
                        className="btn-reset"
                        onClick={this.handleReset}
                      >
                        重置
                      </Button>
                      <Button
                        className="btn-m-plus"
                        onClick={() => this.showAddModal(undefined, 'create')}
                      >
                        <Icon type="plus" />
                        {i18n.t('create')}
                      </Button>
                      <Button
                        className="btn-m-delete"
                        disabled={this.state.selectedRowKeys.length === 0}
                        onClick={this.showDeleteConfirm}
                      >
                        <Icon type="delete" />
                        {i18n.t('delete')}
                      </Button>
                    </Form.Item>
                    {this.state.showMoreFilter && (
                      <Button
                        type="link"
                        className="moreFilter"
                        onClick={() => {
                          this.setState({ moreFilter: !moreFilter });
                        }}
                        icon={moreFilter ? 'down' : 'up'}
                      >
                        {moreFilter ? '展开' : '收起'}
                      </Button>
                    )}
                  </div>
                </Form>
                <div className="history-list">
                  <Table
                    loading={loadingOptions}
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={userList}
                    rowKey={record => record.id}
                    className="list-item"
                    scroll={{ x: 1200, y: tableHeight }}
                    locale={{ emptyText: <TableEmpty /> }}
                    pagination={{
                      size: 'small',
                      pageSize: 20,
                      total: total,
                      showTotal: () => `共${total}条`,
                    }}
                    onChange={(pagination, filters, sorter) => {
                      const orderType = { descend: 'DESC', ascend: 'ASC' };
                      const sortType = orderType[sorter.order];
                      const orderField = sorter.columnKey || '';
                      const newState = {
                        page: 1,
                        sortBy: orderField,
                        sort: sortType,
                        searchLoading: true,
                      };
                      this.throttledUserList(newState);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <UserAdd
          visible={this.state.addModalVisible}
          userDetail={this.state.userDetail}
          institutionData={this.state.institutionData}
          userTypeList={this.state.userTypeList}
          roleInfoRecordList={this.state.roleInfoRecordList}
          onCancel={this.hideAddModal}
          type={this.state.detailType}
        />
      </div>
    );
  }
}

export default withRouter(Form.create()(UserManager));
